import { render, staticRenderFns } from "./RatingDisplay.vue?vue&type=template&id=83e4cbd8&"
import script from "./RatingDisplay.vue?vue&type=script&lang=js&"
export * from "./RatingDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83e4cbd8')) {
      api.createRecord('83e4cbd8', component.options)
    } else {
      api.reload('83e4cbd8', component.options)
    }
    module.hot.accept("./RatingDisplay.vue?vue&type=template&id=83e4cbd8&", function () {
      api.rerender('83e4cbd8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2kgZaVD46WDfx/JS/comp/RatingDisplay.vue"
export default component.exports